/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { MvnoBlockListCollectionInterface } from '../../interfaces/collections/MvnoBlockListCollectionInterface';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import MvnoBlockListInterface from '../../interfaces/platform/MvnoBlockListInterface';

const _ = require('underscore');

export class MvnoBlockListLoader {
    private itemLoaders: ItemLoaders;

    private mvnoBlockListCollection: Array<MvnoBlockListInterface> = [];

    constructor(itemLoader: ItemLoaders) {
        this.itemLoaders = itemLoader;
    }

    loadCollection = (
        platformResellerId: number,
        callback: (data: MvnoBlockListCollectionInterface) => void | null,
        options = { propagateDataToCallback: true, dispatchAfterCallback: false }
    ): void => {
        this.itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists')),
            'mvno_block_list_loader_loadCollection',
            [],
            [{ name: 'blockName', value: 'asc' }],
            (data: MvnoBlockListCollectionInterface) => {
                this.mvnoBlockListCollection = [];
                if (data['hydra:totalItems'] && data['hydra:totalItems'] > 0) {
                    data['hydra:member']?.map((item: MvnoBlockListInterface) => {
                        this.mvnoBlockListCollection.push(item);
                    });
                }
                callback(data);
            },
            options
        );
    };

    loadItem = (
        mvnoBlockListId: number,
        callback: (mvnoBlockList: MvnoBlockListInterface) => void,
        options = { propagateDataToCallback: true, dispatchAfterCallback: false }
    ): void => {
        this.itemLoaders.getWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_lists/' + mvnoBlockListId)),
            'mvno_block_list_item_loaders_loadItem',
            (data: MvnoBlockListInterface): void => callback(data),
            options
        );
    };

    getCollection = (): Array<MvnoBlockListInterface> => {
        return this.mvnoBlockListCollection;
    };

    getElementById = (blockId: number): MvnoBlockListInterface | null => {
        return _.find(this.mvnoBlockListCollection, (item: MvnoBlockListInterface) => {
            return item.id === blockId;
        });
    };

    getBlockNameById = (blockId: number): string | null => {
        const block = this.getElementById(blockId);
        return block ? 'prov:b.' + block.blockName : null;
    };
}
